import React from "react";
import "./ManagementDesk.css";
import { useTranslation } from "react-i18next";

const ManagementDesk = () => {

  const { t } = useTranslation();

  return (

    <section className="about_section founder_section" data-aos="fade-up">

      <div className="founder_container">

        {/* TEXT */}

        <div className="founder_text">

          <h2>{t('about_org.founder_title')}</h2>
           <h4>{t('Headingg')}</h4>
           <h4>{t('Headingg2')}</h4>
          <p>{t('about_org.founder_p1')}</p>
          <p>{t('about_org.founder_p2')}</p>
          <p>{t('about_org.founder_p3')}</p>

        </div>

        {/* IMAGE */}

        <div className="founder_image">

          <div className="founder_bg"></div>

          <img
            src={require("../../Asset/Images/Mr.Choudhary.jpeg")}
            alt="Founder"
          />

        </div>

      </div>

    </section>

  );
};

export default ManagementDesk;